import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { filter, startWith, switchMap, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { Raffle } from '../raffle'
import { raffleActions } from '../raffle.actions'
import { raffleSelectors } from '../raffle.selectors'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'raffle-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class RaffleShowComponent implements OnInit {
  public raffle$: Observable<Raffle>
  public raffleId$: Observable<number>
  public isLoading$: Observable<boolean>
  public selectedLanguage$: Observable<string>
  public arrayTabMenuObjects: any[] = []

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.arrayTabMenuObjects = [
      {
        name: '',
        jsonTranslation: 'general.general',
        show: true,
        iconName: 'cube'
      },
      {
        name: 'linked-subscriptions',
        jsonTranslation: 'subscriptionModule.subscriptions',
        show: environment.moduleConfigs.subscriptionModule.isActive,
        iconName: 'credit-card'
      },
      {
        name: 'results',
        jsonTranslation: 'raffleModule.results',
        show: true,
        iconName: 'crown'
      }
    ]
    this.isLoading$ = this.store
      .select(raffleSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.raffleId$ = this.store
      .select(raffleSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.raffle$ = this.raffleId$.pipe(
      tap((id) =>
        this.store.dispatch(
          raffleActions.fetchOneById({
            id,
            params: RequestQueryBuilder.create({
              join: [
                { field: 'linkedSubscriptions' },
                { field: 'course' },
                { field: 'subscription' }
              ]
            })
          })
        )
      ),
      switchMap((raffleId) =>
        this.store.select(raffleSelectors.selectById, raffleId)
      )
    )
  }
}
